import { Position } from '@/types/position'
import { memo, ReactNode } from 'react'
import { PopupProps } from 'semantic-ui-react'

import Icon from '@/ui/Icon'
import Popup from '@/ui/Popup'
import Text from '@/ui/Text'
import { HelpWrapper, LabelWrapper } from './Styles'

interface Props extends PopupProps {
  className?: string
  content: ReactNode
  label?: string
  color?: string
  position?: Position
  popperDependencies?: any[]
}

const Help = ({
  className,
  content,
  label,
  color,
  position = 'top left',
  popperDependencies = [],
  ...rest
}: Props) => {
  const IconComponent = <Icon button name="icon-help" color={color} {...rest} />

  const trigger = label ? (
    <LabelWrapper>
      <Text.Span grey>{label}</Text.Span>
      {IconComponent}
    </LabelWrapper>
  ) : (
    IconComponent
  )

  return (
    <HelpWrapper className={className}>
      <Popup
        hoverable
        wide
        offset={[-10, 0]}
        position={position}
        trigger={trigger}
        content={<Text.P noMargin>{content}</Text.P>}
        popperDependencies={popperDependencies}
      />
    </HelpWrapper>
  )
}

export default memo(Help)
